export default "__VITE_ASSET__Du1Vrpw4__"